<template>
 <h3>个股香草</h3>
  <StockSearchForm  @submit="fetchData" :isSubmitting="isSubmitting" />
     <div v-if="loading" class="loading-mask">
        <div class="loading-spinner"></div>
        <p>加载中...</p>
      </div>

      <div class="filter-group">
          <el-radio-group v-model="selectedStructure" @change="applyFilter" v-if="tableData.length > 0">
            <div class="filter-title">类型：</div>
            <el-radio-button
              v-for="option in options"
              :key="option.value"
              :label="option.value"
            >{{ option.label }}</el-radio-button>
          </el-radio-group>
      </div>
      <div class="filter-group">
      <el-radio-group v-model="selectedStructure_amount" @change="applyPrice" v-if="tableData.length > 0">
        <div class="filter-title">金额：</div>
        <el-radio-button
          v-for="option in total_principal_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
      </div>
        <div class="filter-group">
      <el-radio-group v-model="selectedBrokerage" @change="applyBrokerageFilter" v-if="tableData.length > 0">
        <div class="filter-title">期权公司：</div>
        <el-radio-button
          v-for="option in brokerage_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>
     <div class="filter-group">
      <el-radio-group v-model="selectedTimes" @change="applyBrokerageFilter" v-if="tableData.length > 0">
        <div class="filter-title">期权时长：</div>
        <el-radio-button
          v-for="option in times_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="filteredTableData.length > 0">
      <StockTable :tableData="filteredTableData" :now_str="now_str" />
    </div>

</template>
<script>
import axios from 'axios';
import StockSearchForm from '@/components/StockSearchForm.vue';
import StockTable from '@/components/StockTable.vue';

export default {
  name: 'StockSearchFormPage',
  components: {
    StockSearchForm,
    StockTable
  },
  data() {
    return {

      isSubmitting: false,
      searchQuery: '',
      date:'',
      scode:'',
      warring: '',
      tableData: [],
      originalTableData: [],  // 添加原始数据副本
      selectedStructure: '100%',
      selectedStructure_amount: '1',
      selectedBrokerage: 'all',  // 初始化为默认值
      selectedTimes:'1M',
      options: [
        { value: '80%', label: '80%' },
        { value: '90%', label: '90%' },
        { value: '95%', label: '95%' },
        { value: '100%', label: '100%' },
        { value: '103%', label: '103%' },
        { value: '105%', label: '105%' },
        { value: '110%', label: '110%' }
      ],
      total_principal_options: [
        { value: '1', label: '100w' },
        { value: '2', label: '200w' },
        { value: '3', label: '300w' },
        { value: '4', label: '400w' },
        { value: '5', label: '500w' }
      ],
      brokerage_options: [
        { value: 'all', label: '全部' },
        { value: '银河', label: '银河' },
        { value: '中信', label: '中信' },
        { value: '永安', label: '永安' },
        { value: '浙期', label: '浙期' },
        { value: '国君', label: '国君' },
        { value: '华泰', label: '华泰' },
        { value: '广发', label: '广发' }

      ],
       times_options: [
        { value: '2w', label: '2w' },
        { value: '1M', label: '1M' },
        { value: '2M', label: '2M' },
        { value: '3M', label: '3M' },
        { value: '6M', label: '6M' },

      ],
      total_principal: '1',  // 初始化为默认值
      total_principal_label: '100w',  // 用于存储 label 值
      containerDisplay:false,
      loading: false, // ✅ 新增 loading 状态
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords / this.perPage);
    },
    filteredTableData() {
      let filteredData = this.tableData;
      if (this.selectedStructure) {
        const startIndex = filteredData.findIndex(item => item.structure === this.selectedStructure);
        if (startIndex !== -1) {
          filteredData = filteredData.slice(startIndex, startIndex + 5);
        } else {
          filteredData = [];
        }
      }

      if (this.selectedBrokerage !== 'all') {
        filteredData = filteredData.filter(item => item[this.selectedBrokerage] !== 0);
      }

      return filteredData;
    }
  },
  methods: {

    applyPrice() {
      // 根据 selectedStructure_amount 计算倍数
      const selectedOption = this.total_principal_options.find(option => option.value === this.selectedStructure_amount);

      this.total_principal = selectedOption.value;
      this.total_principal_label = selectedOption.label;  // 直接使用 this.total_principal_label

      this.tableData = this.originalTableData.map(item => {
        return {
          ...item,
          银河: item.银河 * this.total_principal,
          中信: item.中信 * this.total_principal,
          永安: item.永安 * this.total_principal,
          浙期: item.浙期 * this.total_principal,
          国君: item.国君 * this.total_principal,
          中金: item.中金 * this.total_principal,
          华泰: item.华泰 * this.total_principal,
          广发: item.广发 * this.total_principal
        };
      });


    },
    async fetchData(searchQuery,date) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.loading = true; // ✅ 显示加载动画
      try {
        const response = await axios.get(`/api/query`,{
             headers: {
                 'Authorization': `Bearer ${this.$store.getters.token}`
             },
             params: { now_date: date,code:searchQuery }

        });
        const responseData = response.data;
        if (responseData.stock_data_list!= null){
          this.data = responseData;
          this.generateTableData();
          this.containerDisplay = false;
        }else {
           this.data={};
           this.originalTableData =[];
           this.$message.error(responseData.detail||'不是两融标的');
        }
      } catch (error) {
         if (error.response && error.response.data && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
             this.$message.error(this.data.error);
          }

      } finally {
        this.isSubmitting = false;
        this.loading = false; // ✅ 隐藏加载动画
        console.log('请求完成');
      }
    },
    generateTableData() {
      const { date, stock_code, stock_name, stock_data_list } = this.data;
      this.now_str = this.data.now_str;
      this.scode=stock_code.split('.')[0];
      this.tableData = [
               // ... 你的 tableData 生成逻辑 ...
        { date, stock_code, stock_name, structure: '80%',total_principal_label: this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [22, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [23, 14, 99, 6, 99, 99,18,2]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [24, 15, 99, 7, 99, 99,19,3]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [25, 16, 99, 8, 99, 99,20,4]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [26, 17, 99, 9, 99, 99,21,5]) },

        { date, stock_code, stock_name, structure: '90%',total_principal_label: this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [27, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [28, 9, 99, 10, 99, 2,22,6]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [29, 10, 99, 11, 99, 8,23,7]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [30, 11, 99, 12, 99, 14,24,8]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [31, 12, 99, 13, 99, 20,25,9]) },
        { date, stock_code, stock_name, structure: '95%',total_principal_label: this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [32, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [33, 99, 99, 99, 25, 3,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [34, 99, 99, 99, 26, 9,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [35, 99, 99, 99, 27, 15,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [36, 99, 99, 99, 28, 21,99,99]) },


        { date, stock_code, stock_name, structure: '100%',total_principal_label: this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [2, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [3, 4, 2, 2, 3, 4,2,10]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [4, 5, 3, 3, 4, 10,3,11]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [5, 6, 4, 4, 5, 16,4,12]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [6, 7, 5, 5, 6, 22,5,13]) },

        { date, stock_code, stock_name, structure: '103%', total_principal_label: this.total_principal_label,term: '2W', ...this.extractValues(stock_data_list, [7, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [8, 18, 99, 26, 7, 5,6,14]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [9, 19, 99, 27, 8, 11,7,15]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [10, 20, 99, 28, 9, 17,8,16]) },
        { date: '', stock_code: '', stock_name: '', structure: '',  total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [11, 21, 99, 29, 10, 23,9,17]) },
        { date, stock_code, stock_name, structure: '105%',  total_principal_label:this.total_principal_label,term: '2W', ...this.extractValues(stock_data_list, [12, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '1M', ...this.extractValues(stock_data_list, [13, 22, 7, 30, 8, 6,10,18]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '2M', ...this.extractValues(stock_data_list, [14, 23, 8, 31, 9, 12,11,19]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [15, 24, 9, 32, 10, 18,12,20]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '6M', ...this.extractValues(stock_data_list, [16, 25, 10, 33, 11, 24,13,21]) },
        { date, stock_code, stock_name, structure: '110%',total_principal_label:this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [17, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '1M', ...this.extractValues(stock_data_list, [18, 26, 99, 34, 11, 6,14,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '2M', ...this.extractValues(stock_data_list, [19, 27, 99, 35, 12, 12,15,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '3M', ...this.extractValues(stock_data_list, [20, 28, 99, 36, 13, 18,16,22]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '6M', ...this.extractValues(stock_data_list, [21, 29, 99, 37, 14, 24,17,23]) }
      ];
      this.originalTableData = [...this.tableData];
    },
    extractValues(stock_data_list, indices) {
      return {
        银河: (stock_data_list['银河'] != null && stock_data_list['银河'][indices[0]] !== undefined) ? stock_data_list['银河'][indices[0]] : 0,
        中信: (stock_data_list['中信'] != null && stock_data_list['中信'][indices[3]] !== undefined) ? stock_data_list['中信'][indices[3]] : 0,
        永安: (stock_data_list['永安'] != null && stock_data_list['永安'][indices[4]] !== undefined) ? stock_data_list['永安'][indices[4]] : 0,
        浙期: (stock_data_list['浙期'] != null && stock_data_list['浙期'][indices[5]] !== undefined) ? stock_data_list['浙期'][indices[5]] : 0,
        国君: (stock_data_list['国君'] != null && stock_data_list['国君'][indices[6]] !== undefined) ? stock_data_list['国君'][indices[6]] : 0,
        中金: (stock_data_list['中金'] != null && stock_data_list['中金'][indices[2]] !== undefined) ? stock_data_list['中金'][indices[2]] : 0,
        华泰: (stock_data_list['华泰'] != null && stock_data_list['华泰'][indices[1]] !== undefined) ? stock_data_list['华泰'][indices[1]] : 0,
        广发: (stock_data_list['广发'] != null && stock_data_list['广发'][indices[7]] !== undefined) ? stock_data_list['广发'][indices[7]] : 0

      };
    },

    applyBrokerageFilter() {
      // 这个方法在 computed 中的 filteredTableData 已经处理了
    }
  }
}
</script>
<style>
.filter-group {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.el-radio-group {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 8px 10px;
}

.filter-title {
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
}

.el-radio-button {
  margin-left: 8px;
}

.el-radio-button:first-child {
  margin-left: 0;
}

.el-radio-button__inner {
  padding: 8px 15px;
}
.page-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.title-section {
  margin-bottom: 30px;
}

.rules-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 40px;
}

.rule-group {
  margin-bottom: 25px;
}

.rule-group:last-child {
  margin-bottom: 0;
}

.rule-item {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.5;
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


</style>